import React, { useState, useEffect } from "react";
import "./EmployeeLogin.css"; // Reuse AdminLogin styles
import { useNavigate } from "react-router-dom";
import fetchBase from "../utils/fetchBase";

const AdminSignup = () => {
    const [formData, setFormData] = useState({
        organizationName: "",
        email: "",
        password: "",
        confirmPassword: "",
    });
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    const navigate = useNavigate();

    // Watch for any non-empty input
    useEffect(() => {
        const hasInput =
            formData.organizationName.trim() !== "" ||
            formData.email.trim() !== "" ||
            formData.password.trim() !== "" ||
            formData.confirmPassword.trim() !== "";
        setIsTyping(Boolean(hasInput));
    }, [formData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.password !== formData.confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        setError("");

        try {
            const response = await fetch(`${fetchBase}/api/admin/signup`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    organizationName: formData.organizationName,
                    email: formData.email.toLowerCase().trim(),
                    password: formData.password,
                }),
            });

            if (response.ok) {
                setSuccess(true);
                setTimeout(() => {
                    navigate("/admin/login");
                }, 2000);
            } else {
                setError("Signup failed. Try a different email.");
            }
        } catch (err) {
            console.error("Signup error:", err);
            setError("Something went wrong.");
        }
    };

    const passwordsMatch =
        formData.confirmPassword && formData.password === formData.confirmPassword;

    return (
        <div className="login-page">
            <div className="login-card">
                {!success ? (
                    <>
                        <h2 className="title">Register Your Organization</h2>
                        <form className="login-form" onSubmit={handleSubmit}>
                            <input
                                className="input"
                                type="text"
                                name="organizationName"
                                placeholder="Organization Name"
                                value={formData.organizationName}
                                onChange={handleChange}
                                required
                            />
                            <input
                                className="input"
                                type="email"
                                name="email"
                                placeholder="Email Address"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                            <input
                                className="input"
                                type="password"
                                name="password"
                                placeholder="Create Password"
                                value={formData.password}
                                onChange={handleChange}
                                required
                            />
                            <input
                                className="input"
                                type="password"
                                name="confirmPassword"
                                placeholder="Confirm Password"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                required
                            />
                            {formData.confirmPassword && !passwordsMatch && (
                                <p className="error">Passwords do not match</p>
                            )}
                            {formData.confirmPassword && passwordsMatch && (
                                <p style={{ color: 'green', fontSize: '0.9rem' }}>
                                    Passwords match &#10003;
                                </p>
                            )}
                            {error && <p className="error">{error}</p>}
                            <button type="submit" className="submit-button">Sign Up</button>
                        </form>
                        {!isTyping && (
                            <div className="links">
                                <a href="/admin/login">Already registered? Login instead</a>
                            </div>
                        )}
                    </>
                ) : (
                    <div className="success-container">
                        <div className="checkmark-circle">&#x2714;</div>
                        <p>Registration successful!</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdminSignup;
